function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.7652 0.989686C15.0683 0.764804 15.4984 0.789791 15.7732 1.06465C16.0756 1.36699 16.0756 1.85718 15.7732 2.15952L9.096 8.83789L15.7732 15.5163C16.0756 15.8186 16.0756 16.3088 15.7732 16.6111C15.4984 16.886 15.0683 16.911 14.7652 16.6861L14.6784 16.6111L8 9.93389L1.32163 16.6111L1.2348 16.6861C0.931717 16.911 0.501612 16.886 0.226756 16.6111C-0.0755854 16.3088 -0.0755854 15.8186 0.226756 15.5163L6.904 8.83789L0.226756 2.15952C-0.0755854 1.85718 -0.0755854 1.36699 0.226756 1.06465C0.501612 0.789791 0.931717 0.764804 1.2348 0.989686L1.32163 1.06465L8 7.74189L14.6784 1.06465L14.7652 0.989686Z",
  fill: "#C1C6C9"
});

var SvgBtnIconRemove = function SvgBtnIconRemove(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBtnIconRemove, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/btn-icon-remove.bb757356.svg";
export { ForwardRef as ReactComponent };